import { omit } from 'lodash';
import { questionTypes } from 'sharedParts';

import isPageBreak from './isPageBreak';
import { isQuestionsSection } from '../config/surveySectionsList';

const isTextType = blockType => blockType === questionTypes.staticText;

export const addQuestionNumbers = (blockList, questionNumber = 1) => {
  return blockList.map(
    block =>
      isPageBreak(block) || isTextType(block.type)
        ? block
        : {
            ...block,
            questionNumber: questionNumber++,
          },
  );
};

const clearQuestionNumbers = blockList =>
  blockList.map(block => omit(block, 'questionNumber'));

export const isQuestionBlock = block =>
  isQuestionsSection(block.section) &&
  !isPageBreak(block) &&
  !isTextType(block.type);

export const addNumbersToVisitedQuestions = (blockList, visitedQuestions) => {
  return clearQuestionNumbers(blockList).map(block => {
    if (!isQuestionBlock(block)) {
      return block;
    }

    return visitedQuestions.includes(block.id)
      ? {
          ...block,
          questionNumber: visitedQuestions.indexOf(block.id) + 1,
        }
      : block;
  });
};
